import request from './request'

/**
 * 上传文件
 * @param {File} file - 文件对象
 * @param {string} [module] - 业务模块（可选，用于分类存储）
 * @param {string} [bucket] - 存储桶标识（如 public、private），不传则使用默认桶
 */
export function uploadFile(file, module = 'avatar', bucket = 'public') {
  const formData = new FormData()
  formData.append('file', file)
  if (module) {
    formData.append('module', module)
  }
  if (bucket) {
    formData.append('bucket', bucket)
  }
  return request.post('/file/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
